import React, { useCallback, useMemo, useState } from 'react';
import { IconButton, Tooltip, ClassNameMap } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { CustomLabel } from 'modules/timesheet-labels/labelSchema';
import { CustomLabelSelectorPopper } from './CustomLabelSelectorPopper';

const useStyles = makeStyles((theme) => ({
  addBtn: {
    marginLeft: theme.spacing(1),
    position: 'relative',
    height: theme.spacing(4)
  },
  addIcon: {
    fill: theme.palette.primary.main
  }
}));

type AddCustomLabelProps = {
  addCustomLabel: (customLabel: CustomLabel) => void;
  fieldName: string;
  classes?: ClassNameMap<'addBtn'>;
};
export const AddCustomLabel: React.FC<AddCustomLabelProps> = ({
  addCustomLabel,
  fieldName,
  classes: overrideClasses
}: AddCustomLabelProps) => {
  const classes = useStyles({ classes: overrideClasses });
  const [anchorEl, setAnchorEl] = useState<Element | undefined>(undefined);
  const open = Boolean(anchorEl);

  const label = useMemo(
    () => <FormattedMessage id="customLabels.addCustomLabel" />,
    []
  );

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    },
    []
  );

  const handleClose = useCallback(() => {
    setAnchorEl(undefined);
  }, []);

  return (
    <>
      <Tooltip title={label}>
        <IconButton
          size="small"
          data-testid={'add-custom-label-btn'}
          className={classes.addBtn}
          onClick={handleClick}
        >
          <AddCircleIcon className={classes.addIcon} fontSize="large" />
        </IconButton>
      </Tooltip>
      {open && (
        <CustomLabelSelectorPopper
          open
          actionType="add"
          anchorEl={anchorEl}
          handleClose={handleClose}
          onChange={addCustomLabel}
          fieldName={fieldName}
        />
      )}
    </>
  );
};
